import React, { useEffect, useState } from 'react'

import { message } from 'antd'

export default function useFetchList(
  listFunction,
  dependencyArray = [],
  dontFetch = false,
  mapFunction,
  initialState = [],
  isResponse = false,
  suppressAlert = false,
) {
  const [list, setList] = useState(initialState)
  const [fetching, setFetching] = useState(false)

  async function fetch() {
    if (!dontFetch) {
      setFetching(true)
      try {
        let list = await listFunction()
        if (isResponse === true) list = await list.json()
        if (mapFunction) setList(mapFunction(list))
        else setList(list)
      } catch (e) {
        console.log(e)
        suppressAlert || message.error(e.errorMessage || 'Use Fetch List Not Found')
      }
      setFetching(false)
    }
  }

  useEffect(() => {
    fetch()
    return () => {}
  }, dependencyArray)
  return { list, fetching, setList, fetch }
}
